"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../../components/Button/Button"));
var constants_1 = require("../../constants");
var hooks_1 = require("../../hooks");
var ConfigProvider_1 = require("../../providers/ConfigProvider");
var either_1 = require("../../utils/either");
var utils_1 = require("../../utils/utils");
var DatovaSadaZnalci_1 = require("./DatovaSadaZnalci");
var DatovaSadaTlumocnici = function () {
    var apiUrl = ConfigProvider_1.useConfig().apiUrl;
    var getFile = hooks_1.useGetFile(apiUrl + "/OpenData/");
    var _a = react_1.useState(), fetchError = _a[0], setFetchError = _a[1];
    var isPending = hooks_1.useBoolean(false);
    var _b = react_1.useState(), loadingBtn = _b[0], setLoadingBtn = _b[1];
    var ciselniky = hooks_1.useBoolean(false);
    var getFileName = function (tlumocnici, format) {
        if (tlumocnici) {
            if (format === constants_1.TypyFormatu.CSV)
                return 'TlumocniciPrekladatele.csv';
            if (format === constants_1.TypyFormatu.XML)
                return 'TlumocniciPrekladatele.xml';
            if (format === constants_1.TypyFormatu.XLS)
                return 'TlumocniciPrekladatele.xls';
            return 'TlumocniciPrekladatele.json';
        }
        if (format === constants_1.TypyFormatu.XML)
            return 'TlumocniciPrekladatele_ciselniky.xml';
        return 'TlumocniciPrekladatele_ciselniky.json';
    };
    var getSoubor = function (tlumocnici, format) { return __awaiter(void 0, void 0, void 0, function () {
        var response, downloadError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFetchError(undefined);
                    setLoadingBtn(format);
                    ciselniky.setValue(!tlumocnici);
                    isPending.setTrue();
                    return [4 /*yield*/, getFile({ tlumocnici: tlumocnici, format: format })];
                case 1:
                    response = _a.sent();
                    if (!either_1.isRight(response)) return [3 /*break*/, 3];
                    return [4 /*yield*/, utils_1.downloadFile(response.value, getFileName(tlumocnici, format))];
                case 2:
                    downloadError = _a.sent();
                    if (downloadError) {
                        setFetchError(downloadError);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setFetchError('Stahování selhalo.');
                    isPending.setFalse();
                    return [2 /*return*/];
                case 4:
                    setLoadingBtn(undefined);
                    isPending.setFalse();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(DatovaSadaZnalci_1.Subsection, null,
            react_1.default.createElement(DatovaSadaZnalci_1.H3, null, "Data tlumo\u010Dn\u00EDk\u016F a\u00A0p\u0159ekladatel\u016F"),
            react_1.default.createElement(DatovaSadaZnalci_1.StyledText, null, "Datov\u00E1 sada je exportov\u00E1na do soubor\u016F v\u00A0elektronick\u00E9 podob\u011B z\u00A0informa\u010Dn\u00EDho syst\u00E9mu Seznamy znalc\u016F, tlumo\u010Dn\u00EDk\u016F a\u00A0p\u0159ekladatel\u016F, a\u00A0to v\u00A0rozsahu vymezen\u00E9m v\u00A0\u00A7\u00A016 z\u00E1kona \u010D.\u00A0354/2019\u00A0Sb., o\u00A0soudn\u00EDch tlumo\u010Dn\u00EDc\u00EDch a\u00A0soudn\u00EDch p\u0159ekladatel\u00EDch.")),
        fetchError && !ciselniky.value && (react_1.default.createElement(DatovaSadaZnalci_1.SMessage, { type: "error", onClose: function () { return setFetchError(undefined); } }, fetchError)),
        react_1.default.createElement(DatovaSadaZnalci_1.Row, null,
            react_1.default.createElement(Button_1.default, { name: "tlumocniciDokumentace", primary: true, onClick: function () { return window.open(utils_1.UriKontext() + "/OpenData/Opendata%20dokumentace%20soudn%C3%ADch%20tlumo%C4%8Dn%C3%ADk%C5%AF%20a%20p%C5%99ekladatel%C5%AF.pdf"); } }, "Dokumentace"),
            react_1.default.createElement(DatovaSadaZnalci_1.GrayBtn, { name: "tlumocniciCsv", onClick: function () { return getSoubor(true, constants_1.TypyFormatu.CSV); }, loading: isPending.value && !ciselniky.value && loadingBtn === constants_1.TypyFormatu.CSV, disabled: isPending.value }, "CSV"),
            react_1.default.createElement(DatovaSadaZnalci_1.GrayBtn, { name: "tlumocniciXml", onClick: function () { return getSoubor(true, constants_1.TypyFormatu.XML); }, loading: isPending.value && !ciselniky.value && loadingBtn === constants_1.TypyFormatu.XML, disabled: isPending.value }, "XML"),
            react_1.default.createElement(DatovaSadaZnalci_1.GrayBtn, { name: "tlumocniciJson", onClick: function () { return getSoubor(true, constants_1.TypyFormatu.JSON); }, loading: isPending.value && !ciselniky.value && loadingBtn === constants_1.TypyFormatu.JSON, disabled: isPending.value }, "JSON"),
            react_1.default.createElement(DatovaSadaZnalci_1.GrayBtn, { name: "tlumocniciXls", onClick: function () { return getSoubor(true, constants_1.TypyFormatu.XLS); }, loading: isPending.value && !ciselniky.value && loadingBtn === constants_1.TypyFormatu.XLS, disabled: isPending.value }, "XLS")),
        react_1.default.createElement(DatovaSadaZnalci_1.ZmenaText, null,
            "posledn\u00ED zm\u011Bna dne ",
            utils_1.formatDate(new Date(Date.now()).toString())),
        react_1.default.createElement(DatovaSadaZnalci_1.Subsection, null,
            react_1.default.createElement(DatovaSadaZnalci_1.H3, null, "\u010C\u00EDseln\u00EDkov\u00E1 datov\u00E1 sada tlumo\u010Dn\u00EDk\u016F a\u00A0p\u0159ekladatel\u016F"),
            react_1.default.createElement(DatovaSadaZnalci_1.StyledText, null, "\u010C\u00EDseln\u00EDkov\u00E1 datov\u00E1 sada je exportov\u00E1na do soubor\u016F v\u00A0elektronick\u00E9 podob\u011B z\u00A0informa\u010Dn\u00EDho syst\u00E9mu Seznamy znalc\u016F, tlumo\u010Dn\u00EDk\u016F a\u00A0p\u0159ekladatel\u016F, a\u00A0to v\u00A0rozsahu vymezen\u00E9m v \u00A7\u00A016 z\u00E1kona \u010D.\u00A0354/2019\u00A0Sb., o\u00A0soudn\u00EDch tlumo\u010Dn\u00EDc\u00EDch a\u00A0soudn\u00EDch p\u0159ekladatel\u00EDch.")),
        fetchError && ciselniky.value && (react_1.default.createElement(DatovaSadaZnalci_1.SMessage, { type: "error", onClose: function () { return setFetchError(undefined); } }, fetchError)),
        react_1.default.createElement(DatovaSadaZnalci_1.Row, null,
            react_1.default.createElement(Button_1.default, { name: "tlumocniciCiselnikyDokumentace", primary: true, onClick: function () {
                    return window.open(
                    // eslint-disable-next-line max-len
                    utils_1.UriKontext() + "/OpenData/Opendata%20dokumentace%20%C4%8D%C3%ADseln%C3%ADky%20soudn%C3%ADch%20tlumo%C4%8Dn%C3%ADk%C5%AF%20a%20p%C5%99ekladatel%C5%AF.pdf");
                } }, "Dokumentace"),
            react_1.default.createElement(DatovaSadaZnalci_1.GrayBtn, { name: "tlumocniciCiselnikyJson", onClick: function () { return getSoubor(false, constants_1.TypyFormatu.JSON); }, loading: isPending.value && ciselniky.value && loadingBtn === constants_1.TypyFormatu.JSON, disabled: isPending.value }, "JSON"),
            react_1.default.createElement(DatovaSadaZnalci_1.GrayBtn, { name: "tlumocniciCiselnikyXml", onClick: function () { return getSoubor(false, constants_1.TypyFormatu.XML); }, loading: isPending.value && ciselniky.value && loadingBtn === constants_1.TypyFormatu.XML, disabled: isPending.value }, "XML")),
        react_1.default.createElement(DatovaSadaZnalci_1.ZmenaText, null,
            "posledn\u00ED zm\u011Bna dne ",
            utils_1.formatDate(new Date(Date.now()).toString()))));
};
exports.default = DatovaSadaTlumocnici;
